import { render } from "./MatchStats.vue?vue&type=template&id=0989e866&scoped=true"
import script from "./MatchStats.vue?vue&type=script&lang=js"
export * from "./MatchStats.vue?vue&type=script&lang=js"

import "./MatchStats.vue?vue&type=style&index=0&id=0989e866&scoped=true&lang=css"
import "./MatchStats.vue?vue&type=style&index=1&id=0989e866&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0989e866"]])

export default __exports__